import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Shearchbar.css";
const Navbar = () => {
  const [isHeaderFixed, setIsHeaderFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsHeaderFixed(true);
      } else {
        setIsHeaderFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isHeaderFixed]);

  return (
    <div>
      <header
        style={{ backgroundColor: "black", padding: "0px", zIndex: "4" }}
        className={`.is-sticky  header ${isHeaderFixed ? "fixed" : ""}`}
      >
        <div class="container position-relative">
          <div class="row align-items-center">
            <div class="col-md-8">
              <ul class="main-menu">
                <li class="main-menu-item position-relative">
                  <Link class="main-menu-link text-white" to="/">
                    Home
                  </Link>
                </li>
                <li class="main-menu-item position-static">
                  <Link class="main-menu-link text-white" to="/shop">
                    shop
                  </Link>
                </li>
                
                <li class="main-menu-item position-relative">
                  <Link class="main-menu-link text-white" to="/contect_us">
                    Contact us
                  </Link>
                </li>
              </ul>
            </div>
            
          </div>
        </div>
      </header>
    </div>
  );
};

export default Navbar;
